import React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";

interface PreviewCardProps {
  title: string;
  preview: {
    background: string;
    text: string;
    primary: string;
    secondary: string;
    accent: string;
    chartPalette: string[];
    logoUrl?: string | null;
  };
}

export const PreviewCard: React.FC<PreviewCardProps> = ({ title, preview }) => (
  <Card
    sx={{
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "none",
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        backgroundColor: preview.background,
        color: preview.text,
        px: 3,
        py: 2.5,
      }}
    >
      <Stack spacing={2}>
        <Typography variant="subtitle2">{title}</Typography>
        <Box display="flex" alignItems="center" gap={2}>
          {preview.logoUrl ? (
            <Box
              component="img"
              src={preview.logoUrl}
              alt={`${title} logo`}
              sx={{ maxWidth: 140, maxHeight: 40 }}
            />
          ) : (
            <Box
              sx={{
                width: 120,
                height: 32,
                borderRadius: 1,
                border: "1px dashed",
                borderColor: preview.text,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
              }}
            >
              Logo
            </Box>
          )}
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: preview.primary,
            }}
          />
          <Typography variant="body2" fontWeight={600}>
            Primary button
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {[
            { label: "Primary", color: preview.primary },
            { label: "Secondary", color: preview.secondary },
            { label: "Accent", color: preview.accent },
          ].map((item) => (
            <Box
              key={item.label}
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: 2,
                backgroundColor: item.color,
                color: preview.background,
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              {item.label}
            </Box>
          ))}
        </Stack>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {preview.chartPalette.length ? (
            preview.chartPalette.map((color, index) => (
              <Box
                key={`${color}-${index}`}
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  backgroundColor: color,
                  border: "1px solid rgba(0,0,0,0.08)",
                }}
              />
            ))
          ) : (
            <Typography variant="caption" color="text.secondary">
              Chart palette preview
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  </Card>
);
